import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Tokenomics() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`app ${document.body.classList.contains('dark-theme') ? 'dark-theme' : ''}`}>
      <div className="app-container">
        <div className="nes-container is-rounded with-title">
          <p className="title">Tokenomics</p>
          
          {/* Navigation */}
          <div className="page-navigation">
            <Link to="/" className="nes-btn is-primary">← Home</Link>
            <div className="nav-buttons">
              <Link to="/about" className="nes-btn">About</Link>
              <Link to="/updates" className="nes-btn">Updates</Link>
            </div>
          </div>

          {/* Content */}
          <div className="content-section">
            <h2>$BREK Token Overview</h2>
            <p>The Breakme.ai ecosystem is powered by the <strong>$BREK token</strong>, launched on Solana with the following attributes:</p>
            <ul>
              <li><strong>Contract Address (CA):</strong> <em>CwboyQeaGn6KDRZ96anxx7zesE7eACfBC6vUKE9qpump</em></li>
              <li><strong>Initial Supply:</strong> <em>1 billion tokens</em></li>
              <li><strong>Liquidity Pool:</strong> <em>Automatically locked liquidity from the pump.fun liquidity migration</em></li>
              <li><strong>Team Allocation:</strong> <em>40 million tokens locked for three months via Streamflow Finance</em></li>
            </ul>

            <h2>Upcoming $BREK Utilities</h2>
            <ul>
              <li><strong>Token-Gated Rounds:</strong> <em>Exclusive access to boosted game rounds for token holders</em></li>
              <li><strong>Governance:</strong> <em>Token holders can vote on round parameters and set up custom game rounds</em></li>
              <li><strong>Attempt-Cost Cashback:</strong> <em>Token holders may receive a percentage of the fees they paid at the end of certain rounds</em></li>
            </ul>
          </div>

          <div className="legal-disclaimer">
            <p>DISCLAIMER: The development team reserves all rights to modify, amend, remove, or discontinue any aspect of the platform, features, or functionalities described above at any time and at its sole discretion, without prior notice. Nothing contained herein constitutes financial advice, a solicitation, recommendation, endorsement, or offer to purchase or sell any financial instruments or to participate in any particular trading strategy. All information is provided on an as-is basis for informational purposes only.</p>
          </div>

          {/* Footer Navigation */}
          <div className="page-footer">
            <div className="legal-links">
              <Link to="/disclaimer">Disclaimer</Link>
              <span className="separator">|</span>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms-of-use">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 